<template>
  <post-slider
    v-if="relatedBlogs"
    class="related-blogs"
    :slider="relatedBlogs"
  />
</template>

<script setup lang="ts">
import PostSlider from "~/components/strapi/components/sections/PostSlider/PostSlider.vue";
import { CmsPage } from "~/types/strapi/collection-types/CmsPage";
import { generateStrapiRelatedBlogsParams } from "~/modules/catalog/helpers";
import { StrapiPostSlider } from "~/types/strapi";

const props = defineProps<{
  sku: string | string[];
}>();

const { find } = useStrapiExtend();
const { t } = useI18n();

const { data: relatedBlogs } = useLazyAsyncData("relatedBlogs", async () => {
  const result = await find<CmsPage[]>(
    "cms-pages",
    generateStrapiRelatedBlogsParams(props.sku),
  );

  if (result.data.length) {
    return {
      title: {
        displayText: t("Related blog posts"),
      },
      postSlider: {
        data: result.data,
      },
    } as unknown as StrapiPostSlider;
  }

  return undefined;
});
</script>
<style scoped lang="scss">
.related-blogs {
  @apply pl-0 #{!important};

  &:deep(.strapi-link) {
    @apply text-2xl font-semibold;
  }
  &:deep(.page-section-top) {
    @apply pb-7 pt-10 max-md:pr-[105px];
  }
  &:deep(.swiper) {
    @apply py-5;
  }
  &:deep(.posts-slider__navigations) {
    @apply right-0 top-[36px];
  }
}
</style>
